import { styled } from 'stitches.config'

export const BenefitsRoot = styled('div', {
  background: '$tertiary-200',
})

export const ImageWrapper = styled('div', {
  position: 'relative',
  width: '230px',
  marginRight: 0,

  '@bp3': {
    width: '260px',
    margin: '34px',
  },

  '@bp4': {
    marginRight: '72px',
  },
})

export const Body = styled('div', {

  display: 'none',

  '@bp3': {
    display: 'block',
  },

  '& ul': {
    listStyleType: 'disc', 
    paddingLeft: '$2',
    margin: '$2 0',

    '& li': {
      marginBottom: '0.5rem',
      fontSize: '$h5',
      color: '$accent-black', 

      '&:before': {
        content: '"•"', 
        color: '$accent-black', 
        display: 'inline-block',
        width: '1.5rem',
        marginLeft: '-$1',
      },
    },
  },
});

export const MobileBody = styled('p', {
  display: 'block',
  lineHeight: '$headline',
  marginTop: '24px',
  fontSize: '$headline',
  color: '$accent-black',
  textAlign: 'center',

  '@bp3': {
    display: 'none',
  },
})

export const BenefitsWrapper = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'center',
  alignItems: 'center',
  padding: '72px 24px',
  gap: '$4',

  maxWidth: '380px',
  margin: 'auto',

  '@bp3': {
    flexDirection: 'row',
    justifyContent: 'space-between',
    gap: 0,
    maxWidth: '1800px',
    padding: '72px 72px',
  },
})
